import { render, staticRenderFns } from "./AddCommentForm.vue?vue&type=template&id=7cef2dae&scoped=true&"
import script from "./AddCommentForm.vue?vue&type=script&lang=js&"
export * from "./AddCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cef2dae",
  null
  
)

export default component.exports